<template>
  <div>
    <!-- Main -->
    <div class="d-md-flex h-md-100 align-items-center">
      <div class="col-md-7 p-0 bg-indigo h-md-100 logoarea">
        <div
          class="text-white d-md-flex align-items-center h-100 p-5 text-center justify-content-center"
        >
          <div class="pt-5 pb-5"></div>
        </div>
      </div>
      <div class="col-md-5 p-0 bg-white h-md-100 loginarea">
        <div class="d-md-flex col-12 align-top">
          <img src="@/resources/img/ktb-logo.png" width="152" height="56" style="padding-top: 10px;">
          <img src="@/resources/img/h_elg.jpg" width="284" height="58">
          <router-link to="Login">
            <img src="@/resources/img/login.jpg" width="59" height="58">
          </router-link>
        </div>

        <div class="align-items-center h-md-100 p-3 justify-content-center">
          <form @submit.prevent="validateCustomer" class="rounded p-5">
            <div class="form-group-wrapper">
              <div class="form-group">
                <label class="have-text" for="custTaxID">Tax ID</label>

                <input
                  type="number"
                  v-model="taxId"
                  name="taxId"
                  v-validate="'required|digits:13'"
                  :class="{'input': true, 'is-danger': errors.has('taxId') }"
                  placeholder
                  class="form-control"
                >
                <span class="highlight"></span>
                <span class="bar"></span>

                <span
                  v-show="errors.has('taxId')"
                  class="help is-danger"
                >Tax ID ต้องเป็นตัวเลข 13 หลัก</span>
              </div>

              
              <div class="form-group">
                <label
                  class="have-text"
                  for="custBeneficiary"
                >ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)</label>

                <v-select
                  v-model="beneficiary"
                  name="beneficiary"
                  class="vue-select1"
                  v-validate="{required:true}"
                  :class="{'input': true, 'is-danger': errors.has('beneficiary') }"
                  @input="getLgTypeList()"
                  :options="beneficiaryList"
                  label="nameTH"
                >
                  <!--<option disabled value>เลือกผู้รับผลประโยชน์</option>-->
                 <!-- <option
                    v-for="option in beneficiaryList"
                    v-bind:value="{ beneTaxId: option.taxid, beneGroup: option.group, beneName: option.nameTH}"
                  >{{ option.nameTH }}</option>-->

                  

                  
                </v-select>


    
                <span
                  v-show="errors.has('beneficiary')"
                  class="help is-danger"
                >ระบุ ผู้รับผลประโยชน์</span>
              </div>
              <div class="form-group">
                <label class="have-text" for="custLgType">ประเภทค้ำประกัน</label>
<!--ooooo<v-select class="vue-select1" name="select1"
                    :options="options1"
                    language="">
        </v-select>-->

                <select
                  v-model="lgTypeObj"
                  name="lgTypeObj"
                  ref="refLgType"
                  class="form-control"
                  v-validate="{required:true}"
                  :class="{'input': true, 'is-danger': errors.has('lgType') }"
                >
                  <option disabled value>เลือกประเภทค้ำประกัน</option>
                  <option
                    v-for="option in custLgTypeList"
                    v-bind:value="{ contingentId: option.contingentTypeId, mtContingentId: option.mtContingentId}"
                  >{{ option.contingentTypeNameTh }}</option>
                </select>
                <span v-show="errors.has('refLgType')" class="help is-danger">ระบุ ประเภทค้ำประกัน</span>
              </div>
              <div class="form-group">
                <label class="have-text" for="custAmount">จำนวนเงินค้ำประกัน(บาท)</label>

                <vue-numeric
                  separator=","
                  v-bind:precision="2"
                  v-model="amount"
                  name="amount"
                  class="form-control"
                  v-validate="{required:true,min_value:1}"
                  :class="{'input': true, 'is-danger': errors.has('amount') }"
                ></vue-numeric>
                <span
                  v-show="errors.has('amount')"
                  class="help is-danger"
                >จำนวนเงินค้ำประกัน ไม่ถูกต้อง</span>
              </div>

              <recaptcha
                sitekey="6LeSZJoUAAAAAGZFISA4xF41S9Si5sRiPzAZL6Yw"
                :callback="callbackRecaptchaToken"
              ></recaptcha>

              <button type="submit" class="btn btn-info btn-round btn-block shadow-sm">ตกลง</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- End Main -->

    <footer class="ft-content space-up">
      <div class="container">
        <div class="row">
          <div class="col-6 text-left">
            <i class="feather-icon icon-phone"></i>
            <span>02-111-1111, 02-111-9999 KTB Call Center</span>
          </div>

          <div class="col-6 text-right">
            <span class="text-red">การทำรายการหลังเวลา 15.00 น. ถือว่าเป็นการทำรายการของวันทำการถัดไป</span><br>
            <i class="fa fa-copyright"></i>
            <span>สงวนสิทธิ์ พ.ศ. 2562 บมจ. ธนาคารกรุงไทย Build Date : {{buildVersion}}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
import { apiClient } from "@/utils/apiClient";
import recaptcha from "@/components/captcha/recaptcha";

export default {
  name: "validateCustomer",
  components: { recaptcha },
  data() {
    return {
      taxId: "",
      beneficiary: "",
      beneficiaryList: [],
      custLgType: "",
      custLgTypeList: [],
      lgType: "",
      lgTypeObj: {
          contingentId: "", 
          mtContingentId: ""
      },
      amount: "",
      catchaToken: "",
      sitKey:process.env.VUE_APP_CATCHA_KEY,
      buildVersion:process.env.VUE_APP_BUILD_VERSION,
    };
  },
  mounted() {
    
   apiClient.get("/api/home/getBeneficiary").then(resp => {
      this.beneficiaryList = resp.data;
    });
    
  },
  methods: {
    callbackRecaptchaToken(token) {
      // this.loader.hide()

      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        //swal("Good job!", "" + token, "success");
        this.catchaToken = token;
      } else {
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
        alert("please check you are not robot");
      }
    },

    getLgTypeList: function() {
      
      const { taxId, beneficiary, lgTypeObj, amount } = this;
      //typeof vm.beneficiary;
      this.loader = this.$loading.show();
      apiClient
        .get("/api/home/getContingentByTaxId/" + beneficiary.taxid)
        .then(resp => {
          this.custLgTypeList = resp.data;

          if (resp.data.length > 0) {
              this.lgTypeObj = {
                contingentId :resp.data[0].contingentTypeId,
                mtContingentId: resp.data[0].mtContingentId
              };
          }

          this.loader.hide();
        });
    },

    validateCustomer: function() {
      const { taxId, beneficiary, lgTypeObj, amount } = this;
      //this.catchaToken = "xxxx";
      if (this.catchaToken === "") {
        this.$swal("ไม่สามารถดำเนินการได้", "กรุณาเลือก I'm not a robot", "error");
      } else {
        
        this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          } else {
            this.loader = this.$loading.show();
            apiClient
              .post("/api/customer/verify", {
                taxId: this.taxId,
                beneficiary: this.beneficiary.taxid,
                lgType: this.lgTypeObj.mtContingentId,
                amount: this.amount,
                catchaToken: this.catchaToken
              })
              .then(resp => {
                //set localStorage

                // alert(resp.data.registerVerifyId);
                localStorage.setItem("taxId", taxId);
                //localStorage.setItem("beneTaxId", beneficiary.beneTaxId);
                //localStorage.setItem("beneGroup", beneficiary.beneGroup);
                //localStorage.setItem("beneName", beneficiary.beneName);
                localStorage.setItem("beneTaxId", beneficiary.taxid);
                localStorage.setItem("beneGroup", beneficiary.group);
                localStorage.setItem("beneName", beneficiary.nameTH);
                localStorage.setItem("lgType", lgTypeObj);//mtContingentType
                localStorage.setItem("mtContingentId", this.lgTypeObj.mtContingentId);
                localStorage.setItem("contingentId", this.lgTypeObj.contingentId);
                //localStorage.setItem("lgFormNo", this.lgTypeObj.lgFormNo);
                localStorage.setItem("amount", amount);
                localStorage.setItem("registerVerifyId",resp.data.registerVerifyId);

                if (resp.data.code === "0000") {
                  this.$router.push("/login");
                } else if(resp.data.code === "0002"){
                  this.$swal("ไม่สามารถดำเนินการได้", resp.data.message, "error");
                } else {
                  this.$router.push("/nonCustContact");
                }

                this.loader.hide();
              });
          }
        });
      }
    },

    validate() {
      // validate your form , if you don't have validate prop , default validate pass .
      return true;
    },
    callback(token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        //console.log(token);
        this.validateCustomer();
      } else {
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
        alert("please check you are not robot");
      }
    }
  }
};
</script>
